import { get, del, post } from '../../../utils/api';

export default {
  getCards: () => get({ url: 'user/card' }),
  deleteCard: card_id => del({ url: 'user/card/delete', data: { card_id } }),
  setActiveCard: card_id => post({ url: 'user-card/set-active', data: { card_id } }),
  addCard: CardCryptogramPacket => post({ url: 'user/card/add', data: { CardCryptogramPacket } }),
};
